// A run: its live status, the end-to-end encrypted conversation decrypted in this browser,
// the pending question to answer, and what the host can see of it.
import { RunConversation } from "../workloads/run/RunConversation";
import { RunDetail } from "../workloads/run/RunDetail";

export default function RunDetailPage() {
  return <RunDetail conversation={(props) => <RunConversation {...props} />} />;
}
